import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import classNames from "classnames";
import SlideDown from "react-slidedown";
import { matchPath } from "react-router-dom";
import {faAngleRight} from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Scopes from "Services/Scopes"

class SideNavDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: this.props?.open ?? this.hasActiveChild(),
        };
    }

    hasActiveChild = () => {
        const {items} = this.props;

        return items?.some(({to}) => matchPath(this.props.location.pathname, {
            path: to,
        }));
    };

    toggle = () => this.setState({
        open: !this.state.open,
    });

    render = () => {
        const {icon, label, items} = this.props;
        const {open} = this.state;

        const childItems = items
            ?.filter(({scope}) => !scope || Scopes.has(scope));

        if (!childItems?.length) {
            return null;
        }

        return (
            <div
                className={classNames({
                    'bg-black bg-opacity-25': open,
                })}
            >
                <div
                    onClick={this.toggle}
                    className={classNames(
                        "cursor-pointer group flex items-center px-2 py-2 text-sm leading-5 font-medium focus:outline-none focus:text-white transition ease-in-out duration-150 text-white hover:bg-app-blue-light hover:bg-opacity-50 hover:text-white",
                        {
                            'bg-app-blue-light': open && this.hasActiveChild(),
                        }
                    )}
                >
                    {icon && (
                        <FontAwesomeIcon
                            icon={icon}
                            fixedWidth={true}
                            size="lg"
                            className="mr-2"
                        />
                    )}

                    {label}

                    <div className="ml-auto space-x-2 flex items-center">
                        {items?.filter(({ scope, notification }) => (!scope || Scopes.has(scope)) && notification)?.length > 0 && (
                            <span className="bg-app-red-bright animate-pulse h-2 w-2 rounded-full block"/>
                        ) }

                        <FontAwesomeIcon
                            icon={faAngleRight}
                            size="lg"
                            className={classNames(
                                "transition duration-200",
                                {
                                    "transform rotate-90": open,
                                }
                            )}
                        />
                    </div>
                </div>

                <SlideDown className="duration-200">
                    {open ? (
                        <ul>
                            {childItems
                                ?.map(item => (
                                    <li key={item.label} className="flex group justify-between">
                                        <NavLink
                                            to={item.to}
                                            activeClassName="bg-app-blue-light text-white"
                                            className="pl-10 w-full flex justify-between space-x-2 items-center text-white pr-2 py-2 text-sm leading-5 font-medium transition ease-in-out duration-150 hover:bg-app-blue-light hover:bg-opacity-50 hover:text-white"
                                        >
                                            { item.label }

                                            { item.notification && (
                                                <span className="bg-app-red-bright animate-pulse flex-shrink-0 block h-2 w-2 rounded-full"/>
                                            ) }
                                        </NavLink>
                                    </li>
                                ))}
                        </ul>
                    ) : null}
                </SlideDown>
            </div>
        );
    };
}

export default withRouter(SideNavDropdown);

//
//
// <React.Fragment>
//     <div className="flex items-center">
//                                             <span>
//                                                 Suspended Stock
//                                             </span>
//         {suspendedStockPending > 0 && (
//             <span className="ml-2 bg-red-400 h-2 w-2 rounded-full" />
//         )}
//     </div>
// </React.Fragment>
